<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';

const count = ref(0);
const mounted = ref(false);
const browserInfo = ref('');

const doubleCount = computed(() => count.value * 2);

function increment() {
  count.value++;
}

function decrement() {
  count.value--;
}

onMounted(() => {
  mounted.value = true;

  // Gather browser info for diagnostics
  const ua = navigator.userAgent;
  browserInfo.value = ua;

  console.log('[Vue 3 Test] Component mounted, reactivity working!');
  console.log('[Vue 3 Test] User Agent:', ua);
});
</script>

<template>
  <div>
    <h1>Vue 3 Compatibility Test</h1>

    <div class="card">
      <p>Count:</p>
      <div class="count">{{ count }}</div>
      <p style="color: #666; font-size: 14px;">Double: {{ doubleCount }}</p>
      <div>
        <button @click="decrement">-</button>
        <button @click="increment">+</button>
      </div>
    </div>

    <div class="status" :class="mounted ? 'success' : 'error'">
      <strong>Status:</strong>
      {{ mounted ? 'Vue 3 is working!' : 'Waiting...' }}
    </div>

    <div class="card" style="text-align: left;">
      <h3>Diagnostics</h3>
      <p><strong>Vue Mounted:</strong> {{ mounted ? 'Yes' : 'No' }}</p>
      <p><strong>Reactivity:</strong> {{ count !== undefined ? 'Working' : 'Broken' }}</p>
      <p><strong>Computed:</strong> {{ doubleCount === count * 2 ? 'Working' : 'Broken' }}</p>
    </div>

    <div class="info">
      <p><strong>User Agent:</strong></p>
      <p style="word-break: break-all;">{{ browserInfo }}</p>
    </div>
  </div>
</template>
